import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, Button } from '@material-ui/core';
import instance from '../../../request/http';
import { BASE_URL } from '../../../store/config';
import { timeFormat, timeFormat2, timeFormatS, toMoney } from '../../../common/utils';
import Add from '@material-ui/icons/Add';
import Toast from '../../Layout/components/Toast';
import AlertDialog from '../../Layout/components/AlertDialog';
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import NormalEditor from './NormalEditor';
import { ADD, EDIT } from '../../../common/common';

const Root = styled(Box)({
    width: '100%',
    '& .table': {
        width: '100%',
        borderCollapse: 'collapse',
        border: '1px solid #D8D8D8',
        '& th': {
            height: '70px',
            backgroundColor: '#EDEDED',
            border: '1px solid #D8D8D8'
        },
        '& td': {
            height: '70px',
            backgroundColor: '#FDFBFE',
            border: '1px solid #D8D8D8'
        },
        '& .noBorder': {
            border: 'none',
        },
        '& .final': {
            backgroundColor: '#E3EFF7',
            color: '#142D33',
            fontWeight: 'bold',
        },
        '& .finalReport': {
            fontSize: '24px',
        },
        '& .addBtn': {
            verticalAlign: 'top',
        },
        '& .bgTransparent': {
            backgroundColor: 'transparent',
        },
        '& Button': {
            backgroundColor: '#fff',
        },
    },
})

class PTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAlert: false,
            tempIndex: "",
            total_deposit: 0,
            helperText: "",
            crtServieId: "",
            crtItem: null,

            temp_date: "",
            temp_description: "",
            temp_amount: 0,

            dataArr: [],
            isAdd: false,

            invoiceId: "",
            matterId: "",
            caseBalance: 0,
            invoiceBalance: 0,
            amountAvailable: 0,

            showEditor: false,
            showToast: false,
            toastMsg: "",
            toastState: "",
            typeArr: [
                "Filing Fee",
                "Registered Agent Annual Fee",
                "Printing & Mailing Fee",
                "Third Party Fee"
            ],
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDone = this.handleDone.bind(this);
        this.handleDel = this.handleDel.bind(this);
        this.handleAddItem = this.handleAddItem.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.handleDelItem = this.handleDelItem.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleAutoChange = this.handleAutoChange.bind(this);
        this.closeEditor = this.closeEditor.bind(this);
    }
    render() {
        const {
            crtItem,
            crtServieId,
            showAlert,
            helperText,
            total_deposit,
            tempIndex,
            temp_amount,
            temp_date,
            temp_description,
            amountAvailable,
            dataArr,
            isAdd,
            typeArr,
            showEditor,
            showToast,
            toastMsg,
            toastState,
        } = this.state;
        const { btnName, isDepDisabled, isDisabled } = this.props;
        const editItemView = (type, rowItem, varName, variable, isSelectItem, isMoney = false) => {
            if (isSelectItem) {
                if (type === "date") {
                    if (this.props.type === "deposite") {
                        return <div>
                            {timeFormatS(variable)}
                        </div>
                    } else {
                        return <div className="h h-c">
                            <TextField
                                type="date"
                                variant="outlined"
                                className="textField"
                                value={variable}
                                margin="dense"
                                onChange={e => this.handleChange(e, varName)}
                                style={{ margin: 0, width: '100%', backgroundColor: '#fff' }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </div>
                    }
                } else if (type === "text") {
                    if (this.props.type === "third_party_fee") {
                        return <Autocomplete
                            style={{ margin: 0, width: '100%', backgroundColor: '#fff' }}
                            freeSolo
                            value={variable}
                            options={typeArr}
                            onInputChange={(e, value) => this.handleAutoChange(e, value, varName)}
                            renderInput={(params) => (
                                <TextField {...params} margin="dense" variant="outlined" />
                            )}
                        />
                    }

                    return <div className="h h-c">
                        <TextField
                            margin="dense"
                            variant="outlined"
                            onChange={e => this.handleChange(e, varName)}
                            value={variable}
                            style={{ margin: 0, width: '100%', backgroundColor: '#fff' }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div>
                } else if (type === "number") {
                    return <div className="h h-c">
                        <TextField
                            type="number"
                            margin="dense"
                            variant="outlined"
                            helperText={helperText}
                            onChange={e => this.handleChange(e, varName)}
                            value={variable}
                            style={{ margin: 0, width: '100%', backgroundColor: '#fff' }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div>
                }
            } else {
                if (isMoney) {
                    return <div>${toMoney(rowItem)}</div>
                } else {
                    if (type === "date") {
                        if (this.props.type === "deposite") {
                            return <div>{timeFormatS(rowItem)}</div>
                        } else {
                            return <div>{timeFormat(rowItem)}</div>
                        }
                    } else {
                        return <div>{rowItem}</div>
                    }
                }
            }
        }
        const editItemBtnView = (row, index) => {
            if (tempIndex === index) {
                return <Button disabled={isDisabled} size="small" variant="outlined" color="primary" style={{ marginRight: '10px' }} onClick={this.handleDone}>Save</Button>
            } else {
                return <Button disabled={isDisabled} size="small" variant="outlined" color="primary" style={{ marginRight: '10px' }} onClick={e => this.handleEdit(e, index, row)}>Edit</Button>
            }
        }
        return (
            <Root>
                <table className="table" cellPadding={10}>
                    <thead>
                        <tr>
                            {/* <th width="3%">&nbsp;</th> */}
                            <th width="10%">Date</th>
                            <th>Description</th>
                            <th width="20%">Amount</th>
                            <th width="20%">Operation</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataArr.map((row, index) => (
                            <tr key={index}>
                                {/* <td align="center">&nbsp;</td> */}
                                <td align="center">
                                    {editItemView("date", row.date, "temp_date", temp_date, (tempIndex === index))}
                                </td>
                                <td align="center">
                                    {editItemView("text", row.description, "temp_description", temp_description, (tempIndex === index))}
                                </td>
                                <td align="center">
                                    {editItemView("number", row.amount, "temp_amount", temp_amount, (tempIndex === index), true)}
                                </td>
                                <td align="center">
                                    {editItemBtnView(row, index)}
                                    <Button disabled={isDisabled} size="small" variant="outlined" color="secondary" onClick={e => this.handleDel(e, row)}>Delete</Button>
                                </td>
                            </tr>
                        ))}
                        <tr>
                            <td colSpan={2}>
                                <Button disabled={isDepDisabled || isAdd} className="bgTransparent" color="primary" onClick={this.handleAddItem}>
                                    <Add></Add>
                                    <b>{btnName ? btnName : ""}</b>
                                </Button>
                            </td>
                            <td className="final noBorder" align="center">Total Amount:</td>
                            <td className="final finalReport noBorder" align="center" colSpan={2}>${total_deposit ? toMoney(total_deposit) : 0}</td>
                        </tr>
                    </tbody>
                </table>
                <NormalEditor
                    open={showEditor}
                    type={this.props.type}
                    item={crtItem}
                    itemId={crtServieId}
                    isAdd={isAdd}
                    amountAvailable={amountAvailable}
                    onClose={this.closeEditor}
                ></NormalEditor>
                <AlertDialog
                    open={showAlert}
                    content="Do you want to delete the item?"
                    yesLabel="cancel"
                    noLabel="delete"
                    handleAlertYes={this.handleDelItem}
                    handleAlertNo={this.handleCloseDialog}
                ></AlertDialog>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        )
    }
    componentDidMount() {
    }
    componentDidUpdate(prevProps) {
        if (this.props.invoiceObj !== prevProps.invoiceObj) {
            const invoiceObj = this.props.invoiceObj;
            if (invoiceObj) {
                const matterObj = invoiceObj.matter[0];
                const invoiceId = invoiceObj.id;
                const matterId = matterObj.id;
                const dataArr = invoiceObj[this.props.keyName] ? invoiceObj[this.props.keyName] : [];
                const caseBalance = matterObj.case.balance;
                const invoiceBalance = invoiceObj.balance ? invoiceObj.balance : 0;
                this.setState({
                    invoiceId,
                    matterId,
                    dataArr,
                    caseBalance,
                    invoiceBalance
                }, () => {
                    this.updateTotal();
                    this.updateHelperText();
                });
            }
        }
    }
    updateHelperText() {
        const { caseBalance, invoiceBalance } = this.state;
        const { type, invoiceObj } = this.props;
        if (type === "deposite") {
            //比对case balance和invoice balance取最小
            console.log(caseBalance);
            const cBalance = caseBalance;
            const iBalance = (invoiceBalance >= 0) ? invoiceBalance : 0;
            const minNum = Math.min(cBalance, iBalance);
            const amount = invoiceObj.deposites.length > 0 ? invoiceObj.deposites[0].amount : 0;
            const amountAvailable = minNum + amount;
            console.log("=deposite=", minNum, amount)
            const helperText = "Amount Available: $" + amountAvailable;
            this.setState(() => ({
                helperText,
                amountAvailable
            }))
        }
    }
    addUseData(id) {
        const { type } = this.props;
        const { invoiceId } = this.state;
        const name = type + '_ids';
        const ids = [id];
        this.useData(invoiceId, name, ids);
    }
    handleAddItem(e) {
        this.setState({
            showEditor: true,
            crtServieId: -1,
            crtItem: null,
            isAdd: true,
        });
        // this.setState(() => ({
        //     isAdd: true
        // }));
        // this.addNewItem();
    }
    handleChange(e, name) {
        const value = e.target.value;
        const { caseBalance, invoiceBalance } = this.state;
        const { type, invoiceObj } = this.props;
        if (type === "deposite" && name === "temp_amount") {
            //比对case balance和invoice balance取最小
            const cBalance = (caseBalance >= 0) ? caseBalance : 0;
            const iBalance = (invoiceBalance >= 0) ? invoiceBalance : 0;
            const minNum = Math.min(cBalance, iBalance);
            const amount = invoiceObj.deposites.length > 0 ? invoiceObj.deposites[0].amount : 0;
            const amountAvailable = minNum + amount;
            console.log("=depositeChange=", minNum, amount)
            if (value > amountAvailable) {
                this.showToast("No more than $" + amountAvailable, "error");
                return;
            }
        }
        console.log(value)
        this.setState(() => ({
            [name]: value
        }))
    }
    handleAutoChange(e, value, name) {
        console.log(value);
        this.setState(() => ({
            [name]: value
        }));
    }
    handleDel(e, row) {
        const { isAdd, tempIndex } = this.state;
        if (isAdd) {
            const [...dataArr] = this.state.dataArr;
            dataArr.splice(tempIndex, 1);
            this.setState(() => ({
                dataArr
            }))
            this.clearIsAdd();
        } else {
            this.setState(() => ({
                crtServieId: row.id,
                showAlert: true,
            }))
        }
    }
    handleDelItem() {
        const { type } = this.props;
        const { invoiceId, crtServieId } = this.state;
        this.setState(() => ({
            showAlert: false,
        }));
        const name = type + '_ids';
        const ids = [crtServieId];
        this.delUseData(invoiceId, name, ids, () => {
            this.delData(crtServieId, () => {
                this.clearTempsData();
                this.clearIsAdd();
                this.showToast("Successfully deleted", "success");
                this.props.saveInvoice();
            });
        });
    }
    handleCloseDialog() {
        this.setState(() => ({
            showAlert: false,
        }));
    }
    //1.获取当前index
    //2.获取row数据并赋值给临时变量
    handleEdit(e, index, row) {
        this.setState(() => ({
            showEditor: true,
            crtServieId: row.id,
            crtItem: row,
            isAdd: false
        }));
        // this.setItemToTemps(index, row);
    }
    //1.根据获取的index找到data中对应的一条数据
    //2.将临时变量的数据赋值到data对应的obj中
    handleDone(e) {
        // this.setTempsToItem();
    }
    addNewItem() {
        const { dataArr } = this.state;
        let [...dataArrCopy] = dataArr;
        this.clearTempsData();
        const obj = {
            date: "",
            description: "",
            amount: "",
        }
        dataArrCopy.push(obj);
        this.setState(() => ({
            dataArr: dataArrCopy,
            tempIndex: dataArrCopy.length - 1,
        }))
    }
    setItemToTemps(index, obj) {
        let temp_date = "";
        if (this.props.type === "deposite") {
            temp_date = obj.date ? timeFormatS(obj.date) : "";
        } else {
            temp_date = obj.date ? timeFormat2(obj.date) : "";
        }
        this.setState(() => ({
            tempIndex: index,
            temp_date,
            temp_description: obj.description ? obj.description : "",
            temp_amount: obj.amount ? obj.amount : 0,
        }));
    }
    setTempsToItem() {
        const {
            isAdd,
            tempIndex,
            dataArr,
            temp_amount,
            temp_date,
            temp_description,
        } = this.state;
        if (isAdd) {
            const date = temp_date ? temp_date : new Date();
            const description = temp_description;
            const amount = Number(temp_amount).toFixed(2);
            this.addData(date, description, amount);
        } else {
            console.log(temp_description);
            let [...dataArrCopy] = dataArr;
            let obj = dataArrCopy[tempIndex];
            obj.date = temp_date;
            obj.description = temp_description;
            obj.amount = Number(temp_amount).toFixed(2);
            this.editData(obj.id, obj);
        }
        // this.setState({
        //     dataArr: dataArrCopy
        // }, () => {
        //     this.updateTotal();
        //     this.clearTempsData();
        // })
    }
    clearTempsData() {
        let temp_date = "";
        if (this.props.type === "deposite") {
            temp_date = timeFormatS(new Date());
        } else {
            temp_date = timeFormat2(new Date());
        }
        this.setState(() => ({
            tempIndex: "",
            temp_date,
            temp_description: "",
            temp_amount: 0,
        }));
    }
    clearIsAdd() {
        this.setState(() => ({
            isAdd: false
        }));
    }
    updateTotal() {
        const { dataArr } = this.state;
        let total_deposit = 0;
        for (const obj of dataArr) {
            total_deposit += Number(obj.amount);
        }
        this.setState(() => ({
            total_deposit: Number(total_deposit).toFixed(2)
        }))
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    getIds(arr) {
        let idsArr = [];
        for (const obj of arr) {
            idsArr.push(obj.id);
        }
        return idsArr;
    }
    closeEditor(status, item_id) {
        if (status === ADD) {
            this.addUseData(item_id);
        } else if (status === EDIT) {
            this.props.saveInvoice();
        }
        this.setState({
            showEditor: false,
            isAdd: false,
        });
    }
    //----------------request-------------------------------
    // getDatas(matter_id, callback) {
    //     let params = {
    //         matter_id
    //     }
    //     instance.get(BASE_URL + 'billing/' + this.props.type, { params }).then((res) => {
    //         const expectantDataArr = res.data.data;
    //         callback(expectantDataArr);
    //     })
    // }
    addData(date, description, amount) {
        const params = {
            amount: Number(amount),
            date: (Date.parse(date) / 1000).toString(),
            description,
        }
        instance.post(BASE_URL + 'billing/' + this.props.type, params).then((res) => {
            const id = res.data.data.id;
            this.addUseData(id);
        }).catch((err) => {
            // const msg = err.response.data.message;
            // this.showToast(msg, "error");
        })
    }
    useData(invoice_id, name, ids) {
        const params = {
            [name]: ids,
        }
        instance.post(BASE_URL + 'billing/invoices/' + invoice_id + '/' + this.props.type, params).then((res) => {
            this.clearTempsData();
            this.clearIsAdd();
            this.props.saveInvoice();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    delData(id, callback) {
        instance.delete(BASE_URL + 'billing/' + this.props.type + '/' + id).then((res) => {
            callback();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    delUseData(invoice_id, name, ids, callback) {
        const params = {
            [name]: ids,
        }
        instance.delete(BASE_URL + 'billing/invoices/' + invoice_id + '/' + this.props.type, { data: params }).then((res) => {
            callback();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    editData(id, obj) {
        console.log(obj.description);

        const params = {
            amount: Number(obj.amount),
            date: (Date.parse(obj.date) / 1000).toString(),
            description: obj.description,
        }
        instance.put(BASE_URL + 'billing/' + this.props.type + '/' + id, params).then((res) => {
            this.showToast("Successfully modified", "success");
            this.clearTempsData();
            this.props.saveInvoice();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
}

export default PTable;